import NotFoundHook from './not_found';
export const notFoundHook: NotFoundHook = new NotFoundHook();
